import React from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  TouchableOpacityProps,
} from "react-native";

import { BallIndicator } from "react-native-indicators";

import Icon from "component/typography/Icon";
import Text from "component/typography/Text";
import ImageIcon from "component/typography/ImageIcon";

import tinyColor from "tinycolor2";
import { colors, sizes } from "asset/constant";

const Button = (
  props: ButtonT & TouchableOpacityProps & { imageIcon?: ImageIconT }
) => {
  const {
    title,
    icon,
    direction = "rtl",
    width = "100%",
    height = 45,
    square,
    circle,
    radius = sizes.radius.lg,
    contentSeparator = 12,
    bgColor = colors.theme,
    style,
    absolute,
    bordered,
    renderContent,
    loading,
    loadingProps,
    imageIcon,
  } = props;
  const buttonBg = tinyColor(bgColor);
  const contentColor = buttonBg.isDark()
    ? colors.white
    : title?.color || colors.text.normal;

  const styles = StyleSheet.create({
    container: {
      width: circle || square || width,
      height: circle || square || height,
      borderRadius: circle ? 100 : radius,
      backgroundColor: bgColor,
      ...(bordered
        ? { borderWidth: bordered.width, borderColor: bordered.color }
        : {}),
      position: absolute ? "absolute" : "relative",
      top: absolute?.top,
      bottom: absolute?.bottom,
      left: absolute?.left,
      right: absolute?.right,
      alignSelf: "center",
      overflow: "hidden",
      ...style,
    },

    contentContainer: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      flexDirection: direction === "rtl" ? "row-reverse" : "row",
    },

    content: {
      flex: 1,
      width: "100%",
      height: "100%",
      alignSelf: "center",
      justifyContent: "center",
    },

    loadingContainer: {
      flex: 1,
      width: "100%",
      height: "100%",
      position: "absolute",
      alignItems: "center",
      justifyContent: "center",
    },
  });

  return (
    <TouchableOpacity
      disabled={loading || props.disabled}
      activeOpacity={loading ? 1 : 0.85}
      {...(props as TouchableOpacityProps)}
      style={styles.container}
    >
      {renderContent ? (
        renderContent(bgColor, contentColor)
      ) : (
        <>
          {!loading && (
            <View style={styles.contentContainer}>
              {icon && <Icon size={18} color={contentColor} {...icon} />}
              {imageIcon && <ImageIcon color={contentColor} {...imageIcon} />}
              {title?.value && (icon || imageIcon) && (
                <View style={{ width: contentSeparator }} />
              )}
              {title?.value && (
                <Text
                  size={"lg"}
                  align="center"
                  weight={"medium"}
                  color={contentColor}
                  style={{ bottom: 1 }}
                  {...(title as TextT)}
                >
                  {title.value}
                </Text>
              )}
            </View>
          )}
          {loading && (
            <View style={styles.contentContainer}>
              <BallIndicator size={25} color={contentColor} {...loadingProps} />
            </View>
          )}
        </>
      )}
    </TouchableOpacity>
  );
};

export default Button;
